import { setIsLoading } from '../../../store/globalSlice';

export const TASK_DETAIL_PAGE_SIZE = 20;

const getInlineStatuses = (source) =>
  [
    source?.statusOptions,
    source?.statuses,
    source?.validStatuses,
    source?.validStatus,
    source?.availableStatuses,
    source?.cycleStatuses,
    source?.cycleStatus,
    source?.statusData,
  ].find((statusList) => Array.isArray(statusList) && statusList.length);

export const normalizeTaskDetailItems = (items = []) => {
  const details = items.map((detailItem) => ({
    ...detailItem,
    statusOptions:
      getInlineStatuses(detailItem) || getInlineStatuses(detailItem?.parcel),
  }));

  const parcels = details.map((detailItem) => {
    const parcel = detailItem?.parcel || detailItem;

    return {
      ...parcel,
      barcode: detailItem?.barcode,
      id: detailItem?.id ?? parcel?.id,
      parcelNo: detailItem?.parcelNo ?? parcel?.parcel_no,
      lat: detailItem?.lat ?? parcel?.to?.location?.lat,
      lng: detailItem?.lng ?? parcel?.to?.location?.lon,
    };
  });

  return { details, parcels };
};

const openMissionDetail = async ({
  api,
  dispatch,
  item,
  index,
  setSelectedData,
  setSelectedTask,
  setSelectedTaskDetail,
  setMissionNo,
  setOpenDetail,
}) => {
  try {
    dispatch(setIsLoading(true));
    const responseTaskDetail = await api.get(
      `/api/app/v1/shipito/tasks/details`,
      {
        params: {
          id: item?.id,
          pageId: 1,
          pageSize: TASK_DETAIL_PAGE_SIZE,
        },
      }
    );
    const taskDetail = responseTaskDetail?.data?.data || {};
    const taskDetailItems = taskDetail?.items || [];
    const taskStatusOptions = getInlineStatuses(taskDetail);
    const {
      details: taskDetailItemsWithStatuses,
      parcels: ordersData,
    } = normalizeTaskDetailItems(taskDetailItems);
    console.log('ORDERS DATA:', ordersData);

    setSelectedData(ordersData);
    setSelectedTask({
      ...item,
      details: taskDetail,
      statusOptions: taskStatusOptions || [],
    });
    setSelectedTaskDetail(taskDetailItemsWithStatuses);
    setMissionNo(index + 1);
    setOpenDetail(true);
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(setIsLoading(false));
  }
};

export default openMissionDetail;
